import { render, staticRenderFns } from "./AdminOrdersList.vue?vue&type=template&id=ba3e7964&scoped=true"
import script from "./AdminOrdersList.vue?vue&type=script&lang=js"
export * from "./AdminOrdersList.vue?vue&type=script&lang=js"
import style0 from "./AdminOrdersList.vue?vue&type=style&index=0&id=ba3e7964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3e7964",
  null
  
)

export default component.exports